import {
  format,
  formatDistance,
  formatRelative,
  subDays,
  startOfDay
} from 'date-fns';

export const articleTimeRangeStart = () => startOfDay(subDays(new Date(), 3));
